import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Search, GraduationCap, ChevronRight } from "lucide-react";

export default function StudentPicker({ selected, onSelect, autoSelectSingle = false }) {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api
      .get("/students")
      .then((r) => { setStudents(r.data); if (autoSelectSingle && r.data.length === 1 && !selected) onSelect(r.data[0]); })
      .catch((e) => toast.error(apiErr(e)))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = students.filter(
    (s) => s.name?.toLowerCase().includes(q.toLowerCase()) || s.track?.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="card-ta p-3">
      <div className="relative mb-3">
        <Search className="absolute left-3 top-2.5 text-slate-500" size={16} />
        <input
          className="ta-input pl-9"
          placeholder="Öğrenci ara..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="student-search"
        />
      </div>
      {loading ? (
        <div className="py-8 text-center text-slate-500">
          <Loader2 className="animate-spin inline" size={20} />
        </div>
      ) : filtered.length === 0 ? (
        <div className="py-8 text-center text-slate-500 text-sm">Öğrenci bulunamadı.</div>
      ) : (
        <div className="space-y-1 max-h-[70vh] overflow-y-auto" data-testid="student-list">
          {filtered.map((s) => (
            <button
              key={s.id}
              onClick={() => onSelect(s)}
              data-testid={`student-item-${s.id}`}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left transition-colors ${
                selected?.id === s.id ? "bg-blue-600/20 border border-blue-500/40" : "hover:bg-slate-100 border border-transparent"
              }`}
            >
              <div className="w-9 h-9 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
                <GraduationCap className="text-blue-600" size={18} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-slate-900 truncate">{s.name}</div>
                <div className="text-[11px] text-slate-500 truncate">{s.track || "Alan yok"}</div>
              </div>
              <ChevronRight className="text-slate-600" size={16} />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
